import { TenantController } from '../domains/Tenant/infrastructure/controllers/Tenant.controller';
import { inversifyContainer } from '../inversifyContainer';

export class CoreApplication {
  private static instance: CoreApplication;

  public readonly tenantController: TenantController;

  public readonly unifiedRolesController = {
    composeTenantAgnosticRolesEditor: (payload: unknown) => {
      throw new Error(`not implemented, ${payload}`);
    },
  };

  public static getInstance(): CoreApplication {
    if (!CoreApplication.instance) {
      CoreApplication.instance = new CoreApplication();
    }
    return CoreApplication.instance;
  }

  private constructor() {
    this.tenantController = inversifyContainer.get(TenantController);
  }
}
